import { render } from "./ImportSeatsDialog.vue?vue&type=template&id=0d282494"
import script from "./ImportSeatsDialog.vue?vue&type=script&lang=js"
export * from "./ImportSeatsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__